import React, { useEffect, useState } from "react";
import Footer from "../../Components/Footer";
import Header from "../../Components/Header";
import { ApiService } from "../../Components/Services/apiservices";
import { Container } from "react-bootstrap";

let apiServices = new ApiService();

function Faqs() {
    const [faqData, setfaqData] = useState([]);

    useEffect(() => {
        apiServices.getHomeFaqDataRequest()
            .then((res) => {
                if (res.data.status === "success") {
                    setfaqData(res.data.faqdata);
                }
            })
            .catch((err) => {
                console.error("Error fetching FAQ data:", err);
            });
    }, []);

    return (
        <div className="faqs-page homepage2-wrapper about-us-page">
            <Header />
            <style>
            {`
                .faqs-banner-responsive {
                    background-image: url('/assets/img/food/new_banner.jpeg');
                }
                @media (max-width: 768px) {
                    .faqs-banner-responsive {
                        /* REPLACE THIS WITH YOUR MOBILE BANNER IMAGE PATH */
                        background-image: url('/assets/img/food/ourstorym.jpeg');
                    }
                }
                .faqs-accordion-section {
                    max-width: 900px;
                    margin: 0 auto;
                }
                .faqs-accordion-section .accordion-item {
                    border: none;
                    border-bottom: 1px solid rgba(196, 154, 108, 0.3);
                    background: transparent;
                    margin-bottom: 5px;
                    transition: all 0.3s ease;
                }
                .faqs-accordion-section .accordion-item:last-child {
                    border-bottom: 1px solid rgba(196, 154, 108, 0.3);
                }
                .faqs-accordion-section .accordion-button {
                    padding: 25px 15px;
                    font-weight: 500;
                    font-size: 18px;
                    color: #dddddd;
                    background-color: transparent;
                    box-shadow: none;
                    transition: all 0.3s ease;
                    text-align: left;
                }
                .faqs-accordion-section .accordion-button:hover {
                    color: #e3b15a;
                }
                .faqs-accordion-section .accordion-button:not(.collapsed) {
                    color: #e3b15a;
                    background-color: transparent;
                    box-shadow: none;
                    padding-bottom: 15px;
                }
                .faqs-accordion-section .accordion-button:focus {
                    box-shadow: none;
                }
                .faqs-accordion-section .accordion-body {
                    padding: 0 15px 25px 15px;
                    color: #a0a0a0;
                    line-height: 1.9;
                    font-size: 16px;
                    text-align: left;
                }
            `}
            </style>
            <div
                className="banner-header section-padding bg-position-bottom valign bg-img bg-fixed faqs-banner-responsive"
                data-overlay-dark="3"
                style={{
                    backgroundSize: "cover",
                    backgroundPosition: "100%",
                }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 text-center caption mt-90">
                            <h1>FAQs</h1>
                        </div>
                    </div>
                </div>
            </div>

            {/* Intro Section */}
            <section className="our-story-section text-center" style={{ paddingTop: '80px', paddingBottom: '20px' }}>
                <div className="container">
                    <div className="story-text-container-full mb-5">
                        <h2 className="story-title">Frequently Asked Questions</h2>
                        <div className="story-divider mx-auto">
                            <span>&#9830;</span>
                            <span>&#9830;</span>
                            <span>&#9830;</span>
                        </div>
                        <p className="story-description">
                            We've compiled a list of our most commonly asked questions to help you plan your perfect dining experience. If you need any further assistance, please don't hesitate to contact our team.
                        </p>
                    </div>
                </div>
            </section>

            {/* Accordion Section */}
            {faqData && faqData.length > 0 && (
                <section className="faqs__ section-padding faqs-accordion-section" style={{ paddingTop: '20px', paddingBottom: '80px' }}>
                    <Container>
                        <div className="accordion accordion-flush" id="accordionFlushExample">
                            {faqData.map((item, index) => {
                                const collapseId = `flush-collapse-${index}`;
                                const headingId = `flush-heading-${index}`;
                                const isFirst = index === 0;

                                return (
                                    <div className="accordion-item" key={index}>
                                        <h2 className="accordion-header" id={headingId}>
                                            <button
                                                className={`accordion-button ${isFirst ? "" : "collapsed"}`}
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target={`#${collapseId}`}
                                                aria-expanded={isFirst ? "true" : "false"}
                                                aria-controls={collapseId}
                                            >
                                                {item?.faq_title}
                                            </button>
                                        </h2>
                                        <div
                                            id={collapseId}
                                            className={`accordion-collapse collapse ${isFirst ? "show" : ""}`}
                                            aria-labelledby={headingId}
                                            data-bs-parent="#accordionFlushExample"
                                        >
                                            <div
                                                className="accordion-body"
                                                dangerouslySetInnerHTML={{ __html: item?.faq_description }}
                                            />
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </Container>
                </section>
            )}

            <Footer />
        </div>
    );
}

export default Faqs;
